import { ServiceDefinition } from '@pershing/pershing-core';

export class SettingsServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    name: string = 'dbsrest';
    uri: string = 'user/settings';
    version: string = '';

    static getInstance(): ServiceDefinition {
        if (!SettingsServiceDefinition.instance) {
            SettingsServiceDefinition.instance = new SettingsServiceDefinition();
        }
        return SettingsServiceDefinition.instance;
    }
    private constructor() {}
}
